/**
 * 用户角色弹窗选择插件
 * @Author duo
 * @date 2020-01-03
 */
import React from 'react';
import { connect } from 'dva';
import { component_tool, framework_tool, utils_tool } from '@/tool';
import { modelUtils } from "../../../../utils";

let { WizContainer } = framework_tool;
let { WizTag, WizTableTransfer,WizTooltip } = component_tool;
let { $$,checkStrLength } = utils_tool;
/**
 * 左边表格columns
 */
const leftTableColumns = [
  {
    dataIndex: 'title',
    title: '名称',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
  {
    dataIndex: 'code',
    title: '编码',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
  {
    dataIndex: 'remark',
    title: '备注',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  }
];

/**
 * 右边表格columns
 */
const rightTableColumns = [
  {
    dataIndex: 'title',
    title: '名称',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  },
  {
    dataIndex: 'code',
    title: '编码',
    width:100,
    ellipsis:true,
    render: (text) => <WizTooltip title={text} placement="topLeft" >{text}</WizTooltip>,
  }
];

class UserRoleSelect extends WizContainer {

  componentName = 'UserRoleSelect';

  constructor(props) {
    super(props);
    this.state = {
      targetKeys: [],
      personId: props.record && props.record.personId
    }
    this.initTargetKeys = []
  }

  static defaultProps = {
    _ok: this._doRoleUserAdd,
  };

  /**
   * 初始化已选角色
   */
  _doInitParams = () => {
    this.onChange(this.initTargetKeys)
  }

  /**
   * 用户新增角色
   */
  _doRoleUserAdd = () => {
    const { personId, targetKeys } = this.state;
    if (!this.state.targetKeys || ($$.isArray(this.state.targetKeys) && !(this.state.targetKeys).length)) {
      wizNotice.warn("请先选择角色");
    } else if (this.props.record.personId) {
      this.doAction({
        path: "roleUser/updateOrSave",
        payload: {
          key: "roleUserAddKey",
          apiParams: {
            "personId": personId,
            "roleIds": targetKeys
          }
        }
      });
    } else {
      wizNotice.warn("请先选择用户");
    }
  };

  onChange = nextTargetKeys => {
    this.setState({ targetKeys: nextTargetKeys });
  };

  _componentDidMount = () => {
    this._getData();
    this._getRoleUserData();
  };

  propsAndStateOnChange = {
    roleUserList: this._setTargetKeys.bind(this),
    roleUserAddResult: this._setRoleAddState.bind(this)
  };

  /**
   * 得到已有的数据key即roleId
   * @param nextProps
   * @param nextState
   * @returns {boolean}
   * @private
   */
  _setTargetKeys(nextProps, nextState) {
    let targetIds = [];
    nextProps.roleUserList.data.forEach(data => {
      targetIds.push(data.roleId)
    });
    nextState.targetKeys = targetIds;
    this.initTargetKeys = targetIds
    return true;
  }

  /**
   * 保存后返回提示
   * @param nextProps
   * @param nextState
   * @private
   */
  _setRoleAddState(nextProps, nextState) {
    if (nextProps.roleUserAddResult.code === 1) {
      this.initTargetKeys = this.state['targetKeys']
      wizNotice.success("操作成功");
      this.props.changeModal(false);
    } else {
      wizNotice.error(nextProps.roleUserAddResult.msg);
    }

  }

  /**
   * 查询角色列表
   * @private
   */
  _getData() {
    this.doAction({
      path: "role/getListByCondition",
      payload: {
        key: "roleGetListByConditionKey",
        apiParams: {}
      }
    });
  }

  /**
   * 查询用户的角色
   * @private
   */
  _getRoleUserData() {
    this.doAction({
      path: "roleUser/getListByCondition",
      payload: {
        key: "roleUserGetListByConditionKey@" + this.props.record.personId,
        apiParams: {
          "personId": this.props.record.personId
        }
      }
    });
  }


  _render() {
    const { targetKeys } = this.state;
    let listData = this.props.roleList.data ? this.props.roleList.data : [];
    const mockData = [];
    let returnView = null;
    if (listData && listData.length) {
      listData.forEach(({id,name,code,remark}) => {
        mockData.push({
          key: id,
          title: name,
          code: code,
          remark: remark,
          disabled: code === 'Role0006',
        })
      }
      );
    }
    returnView = <WizTableTransfer
      key={this.props.record.personId}
      dataSource={mockData}
      targetKeys={targetKeys}
      onChange={this.onChange}
      filterOption={(inputValue = '', item) => {
        const _inputValue = inputValue.toLocaleLowerCase()
        const title = item.title.toLocaleLowerCase()
        const code = item.code.toLocaleLowerCase()
        const remark = item.remark.toLocaleLowerCase()
        return title.indexOf(_inputValue) !== -1 || code.indexOf(_inputValue) !== -1 || remark.indexOf(_inputValue) !== -1
      }
        // item.title.indexOf(inputValue) !== -1 || item.code.indexOf(inputValue) !== -1 || item.remark.indexOf(inputValue) !== -1
      }
      leftColumns={leftTableColumns}
      rightColumns={rightTableColumns}
    />

    return returnView;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { role, roleUser } = state;
  const roleList = modelUtils.getModelEntity(role, "roleGetListByConditionKey");
  const roleUserList = modelUtils.getModelEntity(roleUser, "roleUserGetListByConditionKey@" + ownProps.record.personId);
  const roleUserAddResult = modelUtils.getModelEntity(roleUser, "roleUserAddKey");

  return {
    roleList: roleList,
    roleUserList: roleUserList,
    roleUserAddResult: roleUserAddResult
  }
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(UserRoleSelect);

